import { Outlet } from 'react-router-dom';
import { WechatSidebar } from './WechatSidebar';

export function WechatLayout() {
  return (
    <div className="h-full w-full flex">
      {/* 左侧导航菜单 */}
      <WechatSidebar />
      {/* 右侧内容区 */}
      <div className="flex-1 min-w-0 overflow-hidden flex flex-col">
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
